import './static/css/header.css';
import Logo from './static/img/logo-25.svg';
import React, { useRef } from 'react';

const Header = ({ scrollPosition }) => {
     const headerRef = useRef();
     const headerItemsRef = useRef();

     const scrolledHeaderClass = "scrolled-header";
     const shadowScrolledHeaderClass = "shadow";

     React.useEffect(() => {
          if (scrollPosition > 100) {
               AddHeader();
          }
          else {
               var visibleHeaderItems = headerItemsRef.current.classList.contains("show");
               if (!visibleHeaderItems) {
                    RemoveHeader();
               }
          }
     });

     const changeHeaderMenu = () => {
          var scrolledHeader = headerRef.current.classList.contains(scrolledHeaderClass);
          if (scrolledHeader) {
               if (scrollPosition < 100 || scrollPosition === undefined) {
                    RemoveHeader();
               }
          } else {
               AddHeader();
          }
     };

     function AddHeader() {
          headerRef.current.classList.add(scrolledHeaderClass);
          headerRef.current.classList.add(shadowScrolledHeaderClass);
     }

     function RemoveHeader() {
          headerRef.current.classList.remove(scrolledHeaderClass);
          headerRef.current.classList.remove(shadowScrolledHeaderClass);
     }

     return (
          <nav class="fixed-top header navbar navbar-expand-lg px-5 py-3" ref={headerRef}>
               <div class="container-fluid">
                    <a class="navbar-brand text-white" href="#">
                         <img alt="Infocerta Informática LTDA" class="align-text-top d-inline-block" src={Logo} /> <span class="color-font">Info</span><span class="black-font">certa</span>
                    </a>

                    <button aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation" class="border-0 navbar-toggler" data-bs-target="#navbarNavDropdown" data-bs-toggle="collapse" onClick={changeHeaderMenu} type="button">
                         <i class="bi bi-list fs-1 menu-icon text-white" />
                    </button>

                    <div class="collapse justify-content-end navbar-collapse" id="navbarNavDropdown" ref={headerItemsRef}>
                         <ul class="navbar-nav">
                              <li class="nav-item">
                                   <a class="nav-link" href="#">
                                        <button class="border-0 btn header-item lead px-lg-2 py-2 rounded-pill text-white" type="button">
                                             Sobre
                                        </button>
                                   </a>
                              </li>
                              <li class="nav-item">
                                   <a class="nav-link" href="#">
                                        <button class="border-0 btn header-item px-lg-4 py-2 rounded-pill text-white" type="button">
                                             Contato
                                        </button>
                                   </a>
                              </li>
                              <li class="nav-item">
                                   <a class="nav-link" href="#">
                                        <button class="border-0 btn btn-primary px-4 py-2 rounded-pill" type="button">
                                             Conhe&ccedil;a a solu&ccedil;&atilde;o Madya
                                        </button>
                                   </a>
                              </li>
                         </ul>
                    </div>
               </div>
          </nav>
     );
}

export default Header;